import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "emptycontent-additional"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["empty-call-view", {
			'empty-call-view--sidebar': $props.isSidebar,
			'empty-call-view--small': $props.isSmall,
		}]),
    "data-theme-dark": ""
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent($options.emptyCallViewIcon), {
      size: $props.isSidebar ? 32 : 64,
      class: "empty-call-view__icon"
    }, null, 8, ["size"])),
    _createElementVNode("h2", null, _toDisplayString($options.title), 1),
    (!$props.isSmall)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($options.message), 1))
            : _createCommentVNode("", true),
          ($options.showLink)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 1,
                variant: "primary",
                onClick: _withModifiers($options.handleCopyLink, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.t('spreed', 'Copy link')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}